export default "__VITE_ASSET__CXEW2$7H__"